export default __webpack_public_path__ + "static/media/plus.8bcfb742.svg";